import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import withStyles, { type WithStyles } from '@material-ui/core/styles/withStyles';
import createStyles from '@material-ui/styles/createStyles';

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const styles = () =>
  createStyles({
    spinner: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  });

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const Spinner = (props: WithStyles<typeof styles>) => {
  return (
    <div className={props.classes.spinner}>
      <CircularProgress />
    </div>
  );
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default withStyles(styles)(Spinner);
